import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCheckCircle = function SvgCheckCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C229.7 0 0 229.7 0 512s229.7 512 512 512 512-229.7 512-512S794.3 0 512 0m0 970.1C259.4 970.1 53.9 764.6 53.9 512S259.4 53.9 512 53.9 970.1 259.4 970.1 512 764.6 970.1 512 970.1m260.5-651.3c-11.2-11.6-29.7-12-41.3-.8L392.9 640.1l-99.5-101.5-1.2-1.2c-11.8-10.9-30.2-10.2-41.1 1.6-11.6 12.4-11.5 31.8.4 44l119.7 122.2c5.5 5.7 13.1 8.9 21 8.9 7.5 0 14.8-2.9 20.2-8.2l359.3-342c12.2-11.9 13-31.2 1.8-44-.2-.3-.6-.7-1-1.1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircle);

export { ForwardRef as default };
